var module = angular.module('components');

module.factory('GenericComponentService', Service);

function Service() {

    return {
        resolveSelectRenderer: resolveSelectRenderer,
        getSelectFilter: getSelectFilter
    };


    function getSelectFilter(query, filterBy) {
        var filterKeys = null;
        if (filterBy) {
            filterKeys = {};
            for (var index in filterBy) {
                filterKeys[filterBy[index]] = true;
            }
        }

        return function (item) {

            if (!query) {
                return true;
            }
            query = query.toLowerCase();

            var keys = (filterKeys) ? filterKeys : item;

            for (var key in keys) {
                ///Exkludera att söka på id
                if (key === 'id') {
                    continue;
                }

                if (typeof key === "string") {
                    var value = item[key];
                    if (typeof value !== "string" || !value) {
                        continue;
                    }
                    if (value.toLowerCase().indexOf(query) > -1) {
                        return true;
                    }
                }
            }


            return false;
        };
    }

    function resolveSelectRenderer(renderer) {
        if (!renderer) {
            return getRenderItemNone(renderer);
        }
        if (typeof renderer === 'string') {
            return getRenderItemSingle(renderer);
        }
        if (renderer instanceof Array) {
            return getRenderItemArray(renderer);
        }

        return getRenderItemNone(renderer);
    }

    function getRenderItemNone(renderer) {
        return function(context, item) {
            return '';
        };
    }

    function getRenderItemArray(renderer) {
        return function(context, item) {
            var value = '';
            if (!item) {
                return '';
            }
            _.forEach(renderer, function(property) {
                value+= (item[property]) ? item[property] + ' ' : '' + ' ';
            });

            return value;
        };
    }

    function getRenderItemSingle(renderer) {
        return function(context, item) {
            if (!item) {
                return '';
            }

            if (item[renderer] instanceof Date) {
                return getDateStringRepresentation(item[renderer]);
            }

            return item[renderer];
        };
    }

    function getDateStringRepresentation(date) {
        var value = '';
        var year = date.getFullYear();
        var month = (date.getMonth().toString().length === 1) ? '0' + date.getMonth().toString() : date.getMonth().toString();
        var day = (date.getDay().toString().length === 1) ? '0' + date.getDay().toString() : date.getDay().toString();
        var hour = (date.getHours().toString().length === 1) ? '0' + date.getHours().toString() : date.getHours().toString();
        var minutes = (date.getMinutes().toString().length === 1) ? '0' + date.getMinutes().toString() : date.getMinutes().toString();
        value = year + '-' + month + '-' + day;

        if (hour !== '00' && minutes !== '00') {
            value += ' ' + hour + ':' + minutes;
        }

        return value;
    }

}
